# This gets automatically populated bij gulp

exports.date = 1529495387
exports.branch = "master"
exports.hash = "76e96eb"
exports.build = 3294
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee